import {
  Text,
  Input,
  FormControl,
  FormLabel,
  Button,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spacer,
  Box,
  Avatar,
  Stack,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  NumberInput,
  NumberInputField,
  Flex,
  Textarea,
  Tag,
  TagLabel,
  TagCloseButton,
} from "@chakra-ui/react";
import { useForm, Controller } from "react-hook-form";
import { useState, useEffect } from "react";
import ConfirmationModal from "../ConfirmationModal";
import { MdOutlineSearch, MdClose } from "react-icons/md";
import { MdOutlineBookmarkAdded } from "react-icons/md";
import { Coach } from "../Coaches/CoachCard";
import { LuEuro } from "react-icons/lu";

export function ModalNewCoach({ isOpen, onClose, usersList }) {
  const [search, setSearch] = useState([]);
  const [userSelected, setUserSelected] = useState(null);
  const [isInputFocused, setInputFocused] = useState(false);
  const [isActivateLoading, setIsActivateLoading] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(null);
  const [users, setUsers] = useState([]);

  const {
    control,
    handleSubmit,
    register: eventRegister,
    setValue,
    reset,
    //getValues,
    //setError,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      userId: null,
      title: null,
      description: null,
      payRate: 0,
    },
    shouldFocusError: false,
  });

  useEffect(() => {
    if (usersList.length === 1) {
      setUserSelected(usersList[0]);
    } else {
      setUsers(usersList);
      setSearch(usersList);
    }
  }, [usersList]);

  const [inputValue, setInputValue] = useState("");
  const [tags, setTags] = useState([]);

  function handleClose(refresh) {
    onClose(refresh);
    setUserSelected(null);
    setTimeout(() => reset(), 100);
  }

  async function handleConfirmActivateModal(response) {
    setIsActivateLoading(true);

    // llamar al backend para guardar

    console.log(response);

    setIsActivateLoading(false);
  }

  const onSubmit = () => setIsConfirmOpen(true);

  function onErrors(errors) {
    console.log("FORM ERRORS:", errors);
  }
  function handleSelectUser(e) {
    const element = e.target.closest(".prevent-select");

    if (element.getAttribute("data-user-selectable") === "false") return;

    setValue("userId", parseInt(element.id));
    setUserSelected(JSON.parse(element.getAttribute("data-user")));
  }

  function handleType(e) {
    const value = e.target.value;
    console.log("test", value);
    const filteredUsers = users.filter(
      (user) =>
        user.name.toLowerCase().includes(value.toLowerCase()) ||
        user.surname1.toLowerCase().includes(value.toLowerCase()) ||
        user.surname2.toLowerCase().includes(value.toLowerCase())
    );

    setSearch(filteredUsers);
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && inputValue.trim() !== "") {
      event.preventDefault();
      setTags([...tags, inputValue.trim().toUpperCase()]);
      setInputValue("");
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  return (
    <>
      <Modal
        onClose={handleClose}
        isOpen={isOpen}
        isCentered
        size={{ base: "sm", sm: "sm", md: "3xl" }}
        borderRadius={"0px"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader mt={2} pb={2} textAlign={"left"}>
            <Text>Nuevo entrenador</Text>
          </ModalHeader>

          <form onSubmit={handleSubmit(onSubmit, onErrors)}>
            <ModalBody pr={{ base: 5, sm: 5, md: 3 }}>
              {isConfirmOpen && (
                <ConfirmationModal
                  title="Confirmación"
                  message="¿Estás seguro que deseas guardar el nuevo entrenador?"
                  yesButton="Sí, continuar"
                  optionalButton="Seguir editando"
                  onConfirm={handleConfirmActivateModal}
                />
              )}
              <Flex align="start" gap={3}>
                <Flex direction="column" flex="1">
                  <FormControl isInvalid={errors.userId}>
                    <FormLabel htmlFor="userId" fontSize="sm">
                      Usuario
                    </FormLabel>
                    <Box maxWidth="396px" position="relative">
                      {!userSelected ? (
                        <>
                          <Box>
                            <InputGroup>
                              <InputLeftElement
                                pointerEvents="none"
                                mt={"-3px"}
                              >
                                <MdOutlineSearch />
                              </InputLeftElement>
                              <InputRightElement mr={0} mt={"-3px"}>
                                <MdClose cursor="pointer" />
                              </InputRightElement>
                              <Input
                                id="userId"
                                {...eventRegister("userId", {
                                  required: "Obligatorio",
                                })}
                                borderBlockEndStyle={"4px yellow solid"}
                                type="text"
                                size="sm"
                                placeholder="Buscar..."
                                onChange={handleType}
                                autoComplete="off"
                                onFocus={() => setInputFocused(true)}
                                onBlur={() =>
                                  setTimeout(() => setInputFocused(false), 100)
                                }
                              />
                            </InputGroup>
                          </Box>
                          <Stack
                            mt={"0.5px"}
                            spacing={0}
                            border="1px solid #e2e8f0"
                            width="100%"
                            maxH="154px"
                            overflow="auto"
                            position="absolute"
                            zIndex={10}
                            bgColor="white"
                            className=""
                            display={isInputFocused ? "flex" : "none"}
                          >
                            {search && search.length > 0
                              ? search.map((user) => (
                                  <HStack
                                    key={user.id}
                                    id={user.id}
                                    className="prevent-select user-box"
                                    data-user={JSON.stringify(user)}
                                    onClick={handleSelectUser}
                                    cursor="pointer"
                                    w="100%"
                                    px={2.5}
                                    py={2}
                                  >
                                    <Avatar
                                      size="sm"
                                      src={user.avatar}
                                      name={`${user.name} ${user.surname1}`.trim()}
                                    />
                                    <Text id="avatar-text" ml={1}>
                                      {user.name + " " + user.surname1}
                                    </Text>
                                  </HStack>
                                ))
                              : null}
                          </Stack>
                        </>
                      ) : (
                        <>
                          <Input
                            id="userId"
                            {...eventRegister("userId", {
                              required: "Obligatorio",
                            })}
                            type="text"
                            size="sm"
                            display="none"
                          />
                          <HStack
                            id={userSelected.id}
                            className="prevent-select"
                            border={"1px solid #e2e8f0"}
                            p={"3px"}
                            pl={3}
                          >
                            <Avatar
                              size="2xs"
                              src={userSelected.avatar}
                              name={`${userSelected.name} ${userSelected.surname1}`.trim()}
                            />
                            <Text id="avatar-text">
                              {userSelected.name +
                                " " +
                                userSelected.surname1 +
                                " " +
                                userSelected.surname2}
                            </Text>
                            <Spacer />
                            <Button
                              size="xs"
                              onClick={() => {
                                setValue("userId", null);
                                setUserSelected(null);
                              }}
                            >
                              Editar
                            </Button>
                          </HStack>
                        </>
                      )}
                    </Box>
                  </FormControl>

                  <HStack py={4}>
                    <FormControl isInvalid={errors.title}>
                      <FormLabel htmlFor="title" fontSize="sm">
                        Título
                      </FormLabel>
                      <Input
                        id="title"
                        placeholder="Introduce un título"
                        size="sm"
                        {...eventRegister("title", {
                          required: "Obligatorio",
                        })}
                      />
                    </FormControl>
                    <FormControl isInvalid={errors.payRate}>
                      <FormLabel htmlFor="payRate" fontSize="sm">
                        Tarifa
                      </FormLabel>
                      <Controller
                        name="payRate"
                        control={control}
                        rules={{ required: "Obligatorio" }}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                        }) => (
                          <InputGroup>
                            <InputRightElement
                              pointerEvents="none"
                              fontSize="1em"
                              top="50%"
                              transform="translateY(-50%)"
                            >
                              <LuEuro />
                            </InputRightElement>
                            <NumberInput
                              id="payRate"
                              w="100%"
                              placeholder="Opcional"
                              size="sm"
                              onBlur={onBlur}
                              value={value || 0.0}
                              onChange={(valueAsString) => {
                                onChange(valueAsString);
                              }}
                              min={0}
                              max={100}
                              precision={2}
                              step={0.2}
                            >
                              <NumberInputField
                                ref={ref}
                                name={name}
                                pr="2.5em"
                              />{" "}
                            </NumberInput>
                          </InputGroup>
                        )}
                      />
                    </FormControl>
                  </HStack>
                  <FormControl isInvalid={errors.description}>
                    <FormLabel htmlFor="description" fontSize="sm">
                      Descripción
                    </FormLabel>
                    <Textarea
                      id="description"
                      placeholder="Introduce una descripción (máx. 60 carácteres)"
                      size="sm"
                      maxLength={60}
                      rows={2}
                      resize="none"
                      {...eventRegister("description", {
                        required: "Obligatorio",
                      })}
                    />
                  </FormControl>
                  <FormControl isInvalid={errors.coachLink} pt={4}>
                    <FormLabel htmlFor="coachLink" fontSize="sm">
                      Enlace
                    </FormLabel>
                    <Input placeholder="Enlace a tu red social" size="sm" />
                  </FormControl>
                  <Flex direction="column" gap={2} pt={4}>
                    <FormControl isInvalid={errors.tags}>
                      <FormLabel htmlFor="tags" fontSize="sm">
                        Etiquetas
                      </FormLabel>
                      <Input
                        placeholder="Introduce un tag y presiona enter"
                        value={inputValue}
                        size="sm"
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                      />
                    </FormControl>
                    <HStack spacing={2} py={2} wrap="wrap">
                      {tags.map((tag, index) => (
                        <Tag
                          size={{base: "sm",sm: "sm", md: "lg"}}
                          key={index}
                          variant="solid"
                          colorScheme="blue"
                        >
                          <TagLabel>{tag}</TagLabel>
                          <TagCloseButton
                            onClick={() => handleRemoveTag(tag)}
                          />
                        </Tag>
                      ))}
                    </HStack>
                  </Flex>
                </Flex>
                <Flex justify="flex-end" display={{ base: "none", md: "flex" }}>
                  <Coach
                    key={1}
                    coachName={
                      userSelected
                        ? `${userSelected.name} ${userSelected.surname1}`.trim()
                        : "Nombre Apellido"
                    }
                    coachTitle={
                      watch(["title"])[0] === null || watch(["title"])[0] === ""
                        ? "Título"
                        : watch(["title"])
                    }
                    coachDescription={
                      watch(["description"])[0] === null ||
                      watch(["description"])[0] === ""
                        ? "Descripción"
                        : watch(["description"])
                    }
                    coachImage={userSelected ? userSelected.avatar : null}
                    coachLink={null}
                    coachTrainings={tags.length !== 0 ? tags.join(";") : "TAG"}
                  />
                </Flex>
              </Flex>
            </ModalBody>
            <ModalFooter pt={0}>
              <Spacer />
              <Button
                onClick={handleClose}
                borderRadius={0}
                alt="Cancelar"
                isDisabled={isActivateLoading}
                mr={2}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                variant={"outline"}
                colorScheme="blue"
                borderRadius={0}
                isLoading={isActivateLoading}
                alt="Guardar sesión"
              >
                Guardar&nbsp;
                <MdOutlineBookmarkAdded />
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
}
